import { useMemo } from 'react'
import {
  UninvitedGuestsListProps,
  UninvitedGuestsList as View
} from 'ui-components'
import { useInviteUserToMapByEmail } from '~map-preview/hooks/useInviteUserToMapByEmail'
import { useMap } from '~map-preview/states/map'
import { useInput } from '~map-preview/states/mapShare'

export const UninvitedGuestsList = () => {
  const map = useMap()
  const input = useInput()
  const { invite } = useInviteUserToMapByEmail()
  const uninvitedGuests = useMemo(() => {
    if (!map || !Object.keys(map).length) return []

    const workspaceGuests = map.workspace.guestCollection.items
    const mapGuests = map.mapGuestAccessCollection.items

    return workspaceGuests.filter(
      (workspaceGuest) =>
        !mapGuests.some(
          (mapGuest) => mapGuest.userId === workspaceGuest.user.id
        )
    )
  }, [map])

  const handleAddGuestClick: UninvitedGuestsListProps['onAddGuestClick'] = (
    selected
  ) => invite(selected.user.email)

  if (input) return null

  return (
    <View
      guests={uninvitedGuests}
      onAddGuestClick={handleAddGuestClick}
    />
  )
}
